
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DodaFront/View/FeaturedJobList",
      function () {
        return require("private-next-pages/DodaFront/View/FeaturedJobList/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DodaFront/View/FeaturedJobList"])
      });
    }
  